import { useEffect, useState } from "react";

export const TITLE_SUFFIX = " - OverWatch";

const stack = [];
let nextOrder = 0;
let originalTitle = null;
let suffix = TITLE_SUFFIX;
let defaultTitle = null;

const applyTitle = () => {
  if (stack.length > 0) {
    document.title = `${stack[stack.length - 1].title}${suffix}`;
    return;
  }
  const restored = defaultTitle ?? originalTitle;
  originalTitle = null;
  if (restored !== null) document.title = restored;
};

const push = (entry) => {
  if (stack.length === 0) originalTitle = document.title;
  const index = stack.findIndex((other) => other.order > entry.order);
  if (index === -1) stack.push(entry);
  else stack.splice(index, 0, entry);
  applyTitle();
};

const remove = (entry) => {
  const index = stack.indexOf(entry);
  if (index !== -1) stack.splice(index, 1);
  applyTitle();
};

export function configurePageTitle(appName) {
  const name = typeof appName === "string" ? appName.trim() : "";
  if (!name) return;
  suffix = ` - ${name}`;
  defaultTitle = name;
  applyTitle();
}

export function usePageTitle(title) {
  const [order] = useState(() => {
    nextOrder += 1;
    return nextOrder;
  });
  const text = typeof title === "string" ? title.trim() : "";

  useEffect(() => {
    if (!text) return undefined;
    const entry = { order, title: text };
    push(entry);
    return () => remove(entry);
  }, [order, text]);
}
